import { useNavigate } from 'react-router-dom';
import { LoginForm } from '@/pages/auth/LoginForm';
import { MODULE_HUB_PATH } from '@/constants/authRoutes';

export function MasterLoginPage() {
  const navigate = useNavigate();

  return (
    <LoginForm
      variant="master"
      showRegisterLink={false}
      onLoginSuccess={(result) => {
        if (result.masterAdmin) {
          navigate('/master', { replace: true });
        } else {
          navigate(MODULE_HUB_PATH, { replace: true });
        }
      }}
    />
  );
}
